<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import AuthService from './lib/AuthService'

export default {
  beforeCreate () {
    // Initialize the AuthService when the app first loads./
    // This will monitor auth state changes and keep the campaign and user settings up to date.
    AuthService.initializeAuth(this.$cognito)
  }
}
</script>
